import { UserAgentApplication } from 'msal';

//export const msalConfig = {

//    authority: 'https://login.microsoftonline.com/01878817-7703-423d-a5ab-4a4806a233ea',

//  //  redirectUri: document.getElementById('root').baseURI,
//    //  clientId: 'a33690d1-91c8-4eed-9915-9ffb881181ba'
//    clientId: "aa7c008c-dade-4f20-9cea-331820793aab",
//    redirectUri: document.getElementById('root').baseURI,
//    /*redirectUri: document.getElementById('root').baseURI + 'signin-oidc'*/
//}
export const msalConfig = {
    auth: {
        clientId: "aa7c008c-dade-4f20-9cea-331820793aab",
        authority: 'https://login.microsoftonline.com/01878817-7703-423d-a5ab-4a4806a233ea',
        /*  redirectUri: window.location.origin, // or your exact redirect*/
        redirectUri: document.getElementById('root').baseURI,
        postLogoutRedirectUri: window.location.origin,
    }
   
};

const apiScopes = ["api://b59a6520-0ff1-42e7-89cd-08e7db47930a/access_as_user"];
// OIDC + API scopes for loginRedirect (consent once)
const loginRequest = { scopes: ["openid", "profile", ...apiScopes] };
export const msalAuth = new UserAgentApplication(msalConfig);
export async function signInAndGetToken() {
    const account = msalAuth.getAccount();
    if (!account) {
        // Not signed in: start login90
        msalAuth.loginRedirect(loginRequest);
        return null;
    }

    try {
        const resp = await msalAuth.acquireTokenSilent({ scopes: apiScopes, account });
        return resp.accessToken;
    } catch (e) {
        // If consent/MFA/CA required, interactive popup will handle it
        const pop = await msalAuth.acquireTokenPopup({ scopes: apiScopes });
        return pop.accessToken;
    }
};